import { render, staticRenderFns } from "./DisplayTestField.vue?vue&type=template&id=22e7e4a2&"
import script from "./DisplayTestField.vue?vue&type=script&lang=ts&"
export * from "./DisplayTestField.vue?vue&type=script&lang=ts&"
import style0 from "./DisplayTestField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports